import React from 'react';
import { slideWrapper } from '../components/slide';
import { Timer } from '../components/timer';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Content } from '../components/content';

export const LibraryPuzzle6 = slideWrapper(({ data, step, getImg }) => {
  const { answers } = step;

  return (
    <>
      <Timer data={data} presentation />
      <Content left={13} top={40}>
        <img width="300px" src={getImg('krampus')} />
      </Content>
      <Content left={18} top={60}>
        <img width="300px" src={getImg('lib-guy')} />
      </Content>
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letterWrapper="t1" letter="a" answers={answers} />
        <PuzzleItem getImg={getImg} letterWrapper="t2" letter="b" answers={answers} />
        <PuzzleItem getImg={getImg} letterWrapper="t3" letter="c" answers={answers} />
        <PuzzleItem getImg={getImg} letterWrapper="t4" letter="d" answers={answers} />
      </PuzzleItemsWrapper>
    </>
  );
});
